import React from 'react';

interface PharmaTraceLogoProps {
  className?: string;
  showText?: boolean;
  variant?: 'light' | 'dark'; // light text for dark headers, dark text for light containers
}

export default function PharmaTraceLogo({ 
  className = "h-10 w-auto", 
  showText = true,
  variant = 'light' 
}: PharmaTraceLogoProps) {
  const isLight = variant === 'light';

  return (
    <div className={`flex items-center space-x-3 select-none ${className}`}>
      {/* Isometric Hexagon / Pill Cube Logo Emblem */}
      <svg 
        viewBox="0 0 160 160" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="h-10 w-10 shrink-0 drop-shadow-sm"
      >
        {/* Outer Isometric Hexagon Frame (White / Light) */}
        <path 
          d="M80 12 L142 48 L142 118 L80 152 L18 118 L18 48 Z" 
          stroke={isLight ? "#FFFFFF" : "#071A36"} 
          strokeWidth="14" 
          strokeLinejoin="round" 
          strokeLinecap="round" 
        />
        
        {/* Inner Isometric Cube Rib (White / Light) */}
        <path 
          d="M80 44 L114 64 L114 100 L80 120 L46 100 L46 64 Z" 
          stroke={isLight ? "#FFFFFF" : "#071A36"} 
          strokeWidth="10" 
          strokeLinejoin="round" 
        />

        {/* Teal Accent Facet Box */}
        <path 
          d="M80 82 L114 100 L80 120 L46 100 Z" 
          fill="#00B4A2" 
        />
        <path 
          d="M80 82 L114 100 L114 116 L80 100 Z" 
          fill="#1C4F8A" 
        />
      </svg>

      {showText && (
        <div className="flex flex-col leading-tight">
          <div className="flex items-baseline space-x-1 font-sans">
            <span className={`text-lg font-black tracking-wider uppercase ${isLight ? 'text-white' : 'text-[#071A36]'}`}>
              PHARMA
            </span>
            <span className="text-lg font-black tracking-widest uppercase text-teal-400">
              TRACE
            </span>
          </div>
          <span className={`text-[9.5px] font-sans font-medium tracking-tight ${isLight ? 'text-slate-300' : 'text-slate-500'}`}>
            Sistema Integral para Control, Trazabilidad y Gestión de Unidosis
          </span>
        </div>
      )}
    </div>
  );
}
